import { Clickable, Tooltip } from '@ahmdigital/ui';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledClickable = styled(Clickable)`
  justify-content: center;
  padding: 1rem 0;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    margin: 0;
    padding-right: 2rem;
    width: auto;
  }
`;

export const StyledCustomerVariables = styled.ul`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    font-size: initial;
    margin-bottom: 1rem;
  }

  li {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;

    &:first-of-type {
      padding-top: 0;
    }

    &.youthDiscount {
      border-top: 1px solid ${({ theme }) => theme.colors.grey30};
    }
  }
`;

export const StyledSpan = styled.span`
  padding-right: 1rem;
`;

export const StyledTooltip = styled(Tooltip)`
  display: inline;
`;
